import { Block } from 'components/Block'
import { GuidebookStep, stepAffairsInOrderData } from 'components/content/guidebook/content'
import { SGridWrapper } from './GuidebookStepAffairsInOrder.styled'
import { GuidebookStepHeader } from 'components/content/guidebook/guidebookStepHeader/GuidebookStepHeader'
import { HighlightedParagraph } from 'components/highlightedParagraph/HighlightedParagraph'
import { PrimaryFakeLink } from 'components/Link'
import { Picture } from 'components/picture/Picture'
import { ShowMore } from 'components/showMore/ShowMore'
import { Trans, useTranslation } from 'next-i18next'
import Router from 'next/router'
import { numberRange } from 'utils/general'
import { useWindowSize } from 'utils/hooks'

export function GuidebookStepAffairsInOrder(props: { step: GuidebookStep }) {
  const { isDesktop } = useWindowSize()
  const { t } = useTranslation('eol_guide')

  return (
    <>
      <GuidebookStepHeader
        step={props.step}
        description={t('eol_guide.step_1.description')}
        image={
          <Picture imageKey={'illustrations/crowd'} alt={'A crowd of people'} sizes={'700px'} />
        }
      />
      <Block>
        <ShowMore offset={'50rem'} disabled={isDesktop}>
          <SGridWrapper>
            {numberRange(7).map((i) => (
              <HighlightedParagraph
                key={i}
                title={t(`eol_guide.step_1.item_${i}.title`)}
                description={
                  <Trans
                    t={t}
                    i18nKey={`eol_guide.step_1.item_${i}.description`}
                    components={{
                      emptyLink: <PrimaryFakeLink />,
                      will: (
                        <PrimaryFakeLink
                          onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            void Router.push('/will')
                          }}
                        />
                      ),
                    }}
                  />
                }
                {...stepAffairsInOrderData[i]}
              />
            ))}
          </SGridWrapper>
        </ShowMore>
      </Block>
    </>
  )
}
